import { KissNavigationSidebar, KissToolbar } from '@kiss/components/kiss-layout';

export interface LayoutVerticalClassic {
  navigationSidebar?: KissNavigationSidebar;
  toolbar?: KissToolbar;
}
